export default "__VITE_ASSET__D1odvEdS__"